(() => {
  if (customElements.get('featured-collection')) {
    return;
  }

  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.swiper = null;
    }

    connectedCallback() {
      const swiperContainer = this.querySelector('[data-swiper]');
      const flip = this.querySelector('[data-flip]');

      if (!swiperContainer) {
        return;
      }

      const swiperOptions = {
        slidesPerView: 2.05,
        spaceBetween: 12,
        reverseDirection: flip ? true : false,
        navigation: {
          nextEl: this.querySelector('.featured-collection__arrow-next'),
          prevEl: this.querySelector('.featured-collection__arrow-prev')
        },
        breakpoints: {
          990: {
            spaceBetween: 32,
            slidesPerView: 2,
          },
        }
      };

      this.swiper = new Swiper(swiperContainer, swiperOptions);
    }
  }

  customElements.define('featured-collection', FeaturedCollection);
})();